/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ExternalTranscoderUpdate
 */
export interface ExternalTranscoderUpdate {
    /**
     * 
     * @type {Array<{ [key: string]: string | undefined; }>}
     * @memberof ExternalTranscoderUpdate
     */
    pathMappings: Array<{ [key: string]: string | undefined; }>;
    /**
     * 
     * @type {string}
     * @memberof ExternalTranscoderUpdate
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof ExternalTranscoderUpdate
     */
    type?: ExternalTranscoderUpdateTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof ExternalTranscoderUpdate
     */
    address: string;
}

/**
* @export
* @enum {string}
*/
export enum ExternalTranscoderUpdateTypeEnum {
    Transkoder = 'transkoder',
    Vantage = 'vantage'
}

export function ExternalTranscoderUpdateFromJSON(json: any): ExternalTranscoderUpdate {
    return ExternalTranscoderUpdateFromJSONTyped(json, false);
}

export function ExternalTranscoderUpdateFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExternalTranscoderUpdate {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'pathMappings': json['path_mappings'],
        'name': json['name'],
        'type': !exists(json, 'type') ? undefined : json['type'],
        'address': json['address'],
    };
}

export function ExternalTranscoderUpdateToJSON(value?: ExternalTranscoderUpdate | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'path_mappings': value.pathMappings,
        'name': value.name,
        'type': value.type,
        'address': value.address,
    };
}


